<template>
  <section>
    <div class="standardItem1">
      <div>{{ obj.title }}</div>
      <div>
        <span v-for="(item, index) in list" :key="index">
          {{ item.label }}{{ obj[item.model] }}&nbsp;&nbsp;&nbsp;
        </span>
        <!-- <span>&nbsp;&nbsp;&nbsp;来源：河南省教育厅</span> -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ComDtoData1',
  components: {},
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    obj: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    handleRoute(v, x) {
      if (v == 5) {
        this.$router.push(x)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.standardItem1 {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: 70%;
  @include fun-layout(2);
  padding: 10px 20px;
  > div {
    &:nth-child(1) {
      font-family: "Microsoft YaHei";
      @include fun-design(1);
      font-weight: bolder;
      text-align: center;
      font-size: 26px;
      color: #333;
    }
    &:nth-child(2) {
      display: flex;
      flex-wrap: wrap;
      padding: 19px 0;
      justify-content: center;
      align-items: center;
      > span {
        font-family: "Microsoft YaHei";
        font-size: 14px;
        color: #999;
        line-height: 24px;
      }
    }
  }
}
</style>
